import classNames from 'classnames';
import React from 'react';

class Error extends React.Component {
  render() {
    let component = null;

    if (this.props.children) {
      component = (
        <div className={ classNames(this.props.className, 'form__error') }>
          { this.props.children }
        </div>
      );
    }

    return component;
  }
}

export default Error;



// WEBPACK FOOTER //
// ./app/components/shared/form/_Error.jsx